import { createFileRoute } from "@tanstack/react-router";
import { FirstCallStepPlaceholder } from "@/app/onboarding-first-win/steps/first-call/first-call-step-placeholder";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/onboarding/first-call"
)({
  component: FirstCallStepPlaceholder,
});
